import { useContext } from "react";
import { ff, flags } from 'functions/roleBasedAccessUtils'
import { useSelector } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { ArrowUturnLeftIcon, PencilSquareIcon } from "@heroicons/react/20/solid"
import moment from "moment";

import OrganizationBillingReceiptSectionDropdown from "components/Billing/OrganizationBillingReceiptSectionDropdown";

export default function OrganizationProratedAthletes({
    proratedType = 'offboard',
    proratedAthletes = [],
    ShowEditAthleteMembershipModal = () => { }
}) {
    const coachId = useSelector((state) => state.user.id)
    const userType = useSelector((state) => state.user.type)
    const adminToolsVisible = useSelector((state) => state.user.adminToolsVisible)
    const organizationId = useSelector((state) => state.user.organizationId)
    const billingLocalTimestamp = useSelector((state) => state.organization.billingLocalTimestamp)
    const canAccessSidebarSalesTools = ff(flags.canAccessSidebarSalesTools, { userType: userType, adminToolsVisible: adminToolsVisible })
    
    const { ShowModal } = useContext(ModalContext)

    const OnAthletePressed = (userId) => {
        const url = `/athlete/${userId}`
        window.open(url, '_blank')
    }

    const ShowReactivateAthleteModalWarning = (athlete) => {
        const modalData = {
            key: ModalKey.ActionWarning,
            size: 'quarter',
            titleText: `Reactivate ${athlete.firstName} ${athlete.lastName}?`,
            bodyText: [
                'This athlete will be added back into your organization and included in your bill',
            ],
            buttonText: 'Reactivate Athlete',
            buttonAction: async () => await ReactivateAthlete(athlete)
        }

        ShowModal(modalData)
    }

    const ReactivateAthlete = async (athlete) => {
        const jsonBody = {
            userId: coachId,
            organizationId: organizationId,
            athleteId: athlete.id,
            athleteStatus: athlete.status,
            membershipAction: 'reactivate',
            localDateString: billingLocalTimestamp.format('YYYY-MM-DD'),
            utcOffsetMinutes: moment().utcOffset(), // UTC offset in minutes for timezone-aware date calculations
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('BILLING', 'POST', '/update_organization_membership', jsonBody)

        // console.log(result)

        if (result.data.status === 'failure') {
            console.error(result)
            return
        }

        window.location.reload()
    }

    // console.log(proratedAthletes);

    if (proratedAthletes.length === 0) return null;

    return (
        <OrganizationBillingReceiptSectionDropdown
            title={proratedType === 'onboard' ? 'Onboarded Athletes' : 'Cancelled Athletes'}
            subTitle={`${proratedAthletes.length} athlete${proratedAthletes.length > 1 ? 's' : ''}`}
        >
            {proratedAthletes.map((athlete, index) => (
                <div
                    key={index}
                    className="flex items-center"
                >
                    <div
                        className='flex-grow flex items-center pl-4 py-4 bg-gray-50 cursor-pointer'
                        onClick={() => OnAthletePressed(athlete.id)}
                    >
                        {canAccessSidebarSalesTools &&
                            <div
                                className="-ml-4 -my-4 h-12 w-10 flex items-center justify-center"
                                onClick={(e) => { e.stopPropagation(); ShowEditAthleteMembershipModal(athlete) }}
                            >
                                <PencilSquareIcon className="ml-1 h-5 w-5 text-gray-400" />
                            </div>
                        }

                        <div className="text-sm pr-1">{athlete.firstName} {athlete.lastName}</div>

                        <div className="text-sm text-gray-500">
                            {athlete.email && <>({athlete.email})</>}
                            {!athlete.email && <>(No Email)</>}
                        </div>

                        <div className="flex-1" />

                        {athlete.activePeriods && athlete.activePeriods.length > 0 &&
                            <>
                                {athlete.activePeriods.length === 1 &&
                                    <div className="text-sm text-gray-500 pr-2">
                                        {moment(athlete.activePeriods[0].startDate).format('MMMM D')} - {moment(athlete.activePeriods[0].endDate).format('MMMM D, YYYY')}
                                    </div>
                                }

                                {athlete.activePeriods.length > 1 &&
                                    <div className="text-sm text-gray-500 pr-2">
                                        Multiple periods
                                    </div>
                                }
                            </>
                        }

                        <div className="text-sm pr-1">
                            ${athlete.price.toFixed(2)}
                        </div>
                    </div>
                    
                    {proratedType === 'offboard' &&
                        <div 
                            className="py-4 pl-4 pr-5 bg-gray-50 text-gray-400 cursor-pointer hover:text-gray-600"
                            onClick={(e) => { e.stopPropagation(); ShowReactivateAthleteModalWarning(athlete) }}
                        >
                            <ArrowUturnLeftIcon className="h-4 w-4" />
                        </div>
                    }
                </div>
            ))}
        </OrganizationBillingReceiptSectionDropdown>
    )
}